export default {"src":"/_next/static/media/logo.f4a33592.svg","height":22,"width":274,"blurWidth":0,"blurHeight":0};